var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { apiUrl } from "@modules/core/config";
var localStorageKey = "__music_meldeplattform_auth_token__";
export var getToken = function () { return window.localStorage.getItem(localStorageKey); };
export var handleUserResponse = function (res) {
    if (res.status && res.statusCode === 200) {
        window.localStorage.setItem(localStorageKey, res.userToken || "");
        return __assign(__assign({}, res.user), { isAdmin: res === null || res === void 0 ? void 0 : res.isAdmin, token: getToken() || "" });
    }
    return null;
};
export var handlePasswordForgotResponse = function (res) {
    if (res.status && res.statusCode === 200) {
        return res.message;
    }
    return "Failed to send resets password email";
};
export var handleChangePasswordResponse = function (res) {
    if (res.status && res.statusCode === 200) {
        return res.message;
    }
    return "Failed to change password";
};
export var login = function (data) {
    return fetch("".concat(apiUrl, "/login"), {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    }).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!response.ok) return [3 /*break*/, 2];
                    _a = handleUserResponse;
                    return [4 /*yield*/, response.json()];
                case 1: return [2 /*return*/, _a.apply(void 0, [_d.sent()])];
                case 2:
                    _c = (_b = Promise).reject;
                    return [4 /*yield*/, response.json()];
                case 3: return [2 /*return*/, _c.apply(_b, [_d.sent()])];
            }
        });
    }); });
};
export var passwordForgot = function (data) {
    return fetch("".concat(apiUrl, "/newPasswordChangeToken"), {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            email: data.username,
        }),
    }).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!response.ok) return [3 /*break*/, 2];
                    _a = handlePasswordForgotResponse;
                    return [4 /*yield*/, response.json()];
                case 1: return [2 /*return*/, _a.apply(void 0, [_d.sent()])];
                case 2:
                    _c = (_b = Promise).reject;
                    return [4 /*yield*/, response.json()];
                case 3: return [2 /*return*/, _c.apply(_b, [_d.sent()])];
            }
        });
    }); });
};
export var passwordResetByToken = function (data) {
    return fetch("".concat(apiUrl, "/changePasswordByToken"), {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    }).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!response.ok) return [3 /*break*/, 2];
                    _a = handlePasswordForgotResponse;
                    return [4 /*yield*/, response.json()];
                case 1: return [2 /*return*/, _a.apply(void 0, [_d.sent()])];
                case 2:
                    _c = (_b = Promise).reject;
                    return [4 /*yield*/, response.json()];
                case 3: return [2 /*return*/, _c.apply(_b, [_d.sent()])];
            }
        });
    }); });
};
export var changePassword = function (data) {
    return fetch("".concat(apiUrl, "/changePassword"), {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    }).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!response.ok) return [3 /*break*/, 2];
                    _a = handleChangePasswordResponse;
                    return [4 /*yield*/, response.json()];
                case 1: return [2 /*return*/, _a.apply(void 0, [_d.sent()])];
                case 2:
                    _c = (_b = Promise).reject;
                    return [4 /*yield*/, response.json()];
                case 3: return [2 /*return*/, _c.apply(_b, [_d.sent()])];
            }
        });
    }); });
};
export var register = function (data) {
    return fetch("".concat(apiUrl, "/register"), {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    }).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!response.ok) return [3 /*break*/, 2];
                    _a = handleUserResponse;
                    return [4 /*yield*/, response.json()];
                case 1: return [2 /*return*/, _a.apply(void 0, [_d.sent()])];
                case 2:
                    _c = (_b = Promise).reject;
                    return [4 /*yield*/, response.json()];
                case 3: return [2 /*return*/, _c.apply(_b, [_d.sent()])];
            }
        });
    }); });
};
export var logout = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, fetch("".concat(apiUrl, "/logout"), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    userToken: getToken(),
                }),
            }).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!response.ok) return [3 /*break*/, 1];
                            window.localStorage.removeItem(localStorageKey);
                            window.location.href = "/";
                            return [2 /*return*/, response.json()];
                        case 1:
                            _b = (_a = Promise).reject;
                            return [4 /*yield*/, response.json()];
                        case 2: return [2 /*return*/, _b.apply(_a, [_c.sent()])];
                    }
                });
            }); })];
    });
}); };
